import classnames from 'classnames/bind'
import React from 'react'

import GridItem, { GridItemProps } from '~/components/GridImageText/GridItem'
import RichText, { RichTextBlock } from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface GridImageTextProps {
  className?: string
  title?: RichTextBlock[]
  items?: GridItemProps[]
}

function GridImageText({ className, title, items }: GridImageTextProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })
  const titleStyle = useStyle({ textPreset: 'title-section-page' })

  return (
    <div className={cx(css.GridImageText, className)}>
      {title && (
        <div className={cx(css.titleWrapper, gridStyle)}>
          <RichText className={cx(css.title, titleStyle)} render={title} />
        </div>
      )}
      <div className={cx(css.itemsGrid, gridStyle)}>
        {items?.map((item, index) => {
          const isOdd = index % 2 !== 0

          return (
            <GridItem
              className={cx(css.box, { isOdd })}
              key={`grid_item_${index}`}
              {...item}
            />
          )
        })}
      </div>
    </div>
  )
}

GridImageText.defaultProps = {}

export default GridImageText
